module.exports = __webpack_public_path__ + "img/627366f.jpg";